export default "__VITE_ASSET__b12ba6be__"